import { DS } from '../../design-system'
import { NotificationDay } from './NotificationDay'

export const NotificationsDays = ({
  days,
  currentDay,
  onPress
}: {
  days: Array<number>
  currentDay: number
  onPress: (day: number) => void
}) => {
  return (
    <DS.Frame justifyContent="space-between" row>
      {days.map((day) => (
        <NotificationDay
          onPress={onPress}
          isSelected={currentDay === day}
          key={`notification-day${day}`}
          day={day.toString()}
        />
      ))}
    </DS.Frame>
  )
}
